import React from 'react';
import PropTypes from 'prop-types';
import CustomizedTable from 'components/common/components/tablev2/CustomizedTable';
import { useSelector } from 'react-redux';
import Icons from 'consts/icons';

const DisplayActivations = props => {
  const { activations, remove } = props;
  const strings = useSelector(state => state.language).zonesDetails.activations;
  const [headers, setHeaders] = React.useState([]);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    if (!activations || !activations.length) {
      setHeaders([]);
      setData([]);
      return;
    }
    prepareData();
  }, [activations]);

  const prepareData = () => {
    if (!activations) return;
    let h;
    let d;
    if (activations.length > 1 || activations[0].type === 'temporary') {
      h = [strings.type_, strings.start_, strings.stop_];
      d = activations.map(a => ({
        uid: a.uid,
        type: a.type,
        start: a.start,
        stop: a.stop,
      }));
    } else if (activations[0].type === 'periodic') {
      h = [strings.type_, strings.days_, strings.hours_];
      d = activations.map(a => ({
        type: a.type,
        days: a.days.map(day => `${strings.days[day]}, `),
        hours: a.hours.map(hour => `${hour}:00, `),
      }));
    } else {
      h = [strings.type_, strings.start_];
      d = activations.map(a => ({
        type: a.type,
        start: a.start,
      }));
    }
    if (remove) {
      h.push(strings.remove_);
      d = d.map(row => ({
        ...row,
        remove: <Icons.Actions.Close onClick={() => remove(row)} />,
      }));
    }
    setHeaders(h);
    setData(d);
  };

  return headers.length ? (
    <CustomizedTable headers={headers} data={data} />
  ) : (
    <span>{strings.noItems_}</span>
  );
};

DisplayActivations.propTypes = {
  activations: PropTypes.array.isRequired,
  remove: PropTypes.func,
};

export default DisplayActivations;
